export default __webpack_public_path__ + "locales/sr-Latn-RS/FilesSettings.json?hash=fdfb652ca0ef2ca210f303e5964cd8be";